import auth0 from 'auth0-js'
import { defined } from '@src/utils/defined'

const auth = new auth0.WebAuth({
  // https://auth0.com/docs/libraries/auth0js/v9#available-parameters
  domain: defined(process.env.AUTH0_DOMAIN),
  clientID: defined(process.env.AUTH0_CLIENT_ID),
  redirectUri: window.location.origin,
  responseType: 'token id_token',
  scope: 'openid profile email',
})

export default window.Cypress
  ? {
      authorize() {
        console.info('auth.authorize')
      },
      parseHash({ hash }, callback) {
        console.info('auth.parseHash')
        if (hash.includes('state=forceValid')) {
          const authResult = hash
            .replace(/^\W/g, '')
            .split('&')
            .map((param) => {
              const [key, value] = param.split('=')
              const camelCasedKey = key.replace(/_(\w)/g, (match, letter) =>
                letter.toUpperCase()
              )
              return { [camelCasedKey]: decodeURIComponent(value) }
            })
            .reduce((a, b) => ({ ...a, ...b }), {})

          const encodedPayload = authResult.idToken.split('.')[1]
          const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/')
          const paddedBase64 = base64.padEnd(
            Math.ceil(base64.length / 4) * 4,
            '='
          )
          authResult.idTokenPayload = JSON.parse(window.atob(paddedBase64))
          callback(null, authResult)
        } else {
          callback({ errorDescription: 'Invalid authentication callback' })
        }
      },
      client: {
        userInfo(accessToken, callback) {
          console.info('auth.client.userInfo')
          const store = require('@state/store').default
          callback(null, store.state.auth.currentUser)
        },
      },
    }
  : auth
